import { Context, PreviewContextValue } from './PreviewContextProvider'
import { useContext } from 'react'

export const usePreview = (): PreviewContextValue | null => {
  return useContext(Context)
}
